import React, { useContext, useState, useEffect } from 'react';
import YesNo from '../../../../../../components/Dialog/YesNo';
import { store } from '../Fleets';
import TextField from '@material-ui/core/TextField';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import axios from '../../../../../../api/axios';
import { store as store2 } from '../../../../../../store';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
  weight: {
    width: '250px',
  },
  weightTitle: {
    fontWeight: 'bold',
    fontSize: 28,
    marginLeft: theme.spacing(1),
  },
}));

const AddFleetDialog = ({ f }) => {
  const classes = useStyles();
  const { state, dispatch, getFleetsAndFleetOptions } = useContext(store);
  const { showMessage, showError } = useContext(store2);
  const [fleet, setFleet] = useState({ weightType: 'Ton' });
  const [error, setError] = useState({});
  const mode = typeof f === 'object' ? 'edit' : 'new';
  const [loading, setLoading] = useState(false);

  const verify = () => {
    let err = {};
    if (!fleet.title) {
      err.title = 'عنوان را وارد نمائید.';
    }
    if (!fleet.maxWeight || fleet.maxWeight * 1 <= 0) {
      err.maxWeight = 'وزن قابل حمل ناوگان باید یک عدد مثبت باشد.';
    }
    return err;
  };
  const handleClose = async (agree) => {
    if (agree) {
      let err = verify();
      if (Object.entries(err).length) {
        setError(err);
        showError('خطا در هنگام ثبت.');
        return;
      }
      try {
        if (fleet.weightType === 'Kg') {
          fleet.maxWeight = fleet.maxWeight / 1000;
        }
        setLoading(true);
        await axios.post(`/api/v1/admin/parameters/fleets`, fleet);
        showMessage('اطلاعات ناوگان ثبت گردید.');
        getFleetsAndFleetOptions();
      } catch (error) {
        console.error(JSON.stringify(error, null, 2));
      }
      setLoading(false);
      dispatch({ type: 'CLOSE_ADD_FLEET_DIALOG' });
    } else dispatch({ type: 'CLOSE_ADD_FLEET_DIALOG' });
  };
  const handleChangeTextField = (e) => {
    const { value, name } = e.target;
    setFleet({ ...fleet, [name]: value });
  };
  const handleChangeToggle = (e, value) => {
    setFleet({ ...fleet, weightType: value });
  };

  useEffect(() => {
    if (mode === 'edit') {
      if (f.weightType === 'Kg') {
        f.maxWeight = f.maxWeight * 1000;
      }
      setFleet(f);
    }
  }, [mode]);

  return (
    <YesNo
      fullWidth
      title={mode === 'edit' ? `ویرایش ناوگان` : 'تعریف ناوگان جدید'}
      yes={mode === 'edit' ? 'ویرایش' : 'افزودن'}
      no="صرفنظر"
      onClose={handleClose}
      endIcon={loading ? <CircularProgress size={10} /> : <></>}
      inProgress={loading}
      loadingButton
    >
      <div className={classes.form}>
        <TextField
          name="title"
          variant="outlined"
          size="medium"
          label="نام ناوگان"
          fullWidth
          onChange={handleChangeTextField}
          value={fleet.title ? fleet.title : ''}
          error={error.title ? true : false}
          helperText={error.title ? error.title : ''}
        />
        <ToggleButtonGroup
          value={fleet.weightType}
          exclusive
          onChange={handleChangeToggle}
          style={{ width: '100%' }}
        >
          <ToggleButton value="Ton" style={{ width: '50%' }}>
            تن
          </ToggleButton>
          <ToggleButton value="Kg" style={{ width: '50%' }}>
            کیلوگرم
          </ToggleButton>
        </ToggleButtonGroup>
        <div>
          <TextField
            type="number"
            error={error.maxWeight ? true : false}
            name="maxWeight"
            value={fleet.maxWeight ? fleet.maxWeight : ''}
            onChange={handleChangeTextField}
            fullWidth
            label="سقف وزن بارگیری ناوگان"
            variant="outlined"
            size="medium"
            className={classes.weight}
            helperText={error.maxWeight ? error.maxWeight : ''}
          />
          <span className={classes.weightTitle}>
            {fleet.weightType === 'Ton' ? <>تن</> : <>کیلوگرم</>}
          </span>
        </div>
      </div>
    </YesNo>
  );
};

export default AddFleetDialog;
